import { atom } from 'recoil';
import axios from '../utils/axios';
// eslint-disable-next-line import/extensions
import localStorageEffect from './localStorageEffect.js';
import { Building } from '../@types/model/user';

const buildingState = atom<Building[]>({
  key: 'buildings',
  default: [],
  effects: [localStorageEffect('buildings')]
});

const getBuildings = async () => {
  let buildings: Building[] = (await axios.get('/api/v2/device-tag')).data.data.filter(
    (dat: any) => {
      if (dat?.attributes?.type === 'asset') return true;
      return false;
    }
  );
  return buildings;
};

export { buildingState, getBuildings };
